import React from "react"
import { SensaiComponentCardsImage } from "../../../gql/generated/graphql"
import { Box } from "@mui/system"
import { Typography } from "@mui/material"
import { GatsbyImage } from "gatsby-plugin-image"
import ContentButton from "./ContentButton"
import theme from "../../../material-ui/theme"

const ImageCard = ({
  card,
  size,
}: {
  card: SensaiComponentCardsImage
  size: "sm" | "md" | "lg"
}) => {
  const { id, title, image, link, cardStyle } = card
  const dark = cardStyle?.style === "dark"
  return (
    <Box
      data-aos="fade-up"
      data-aos-duration="700"
      sx={{
        padding: "1.5rem",
        borderRadius: "1rem",
        position: "relative",
        display: "flex",
        flexDirection: "column",

        ...(dark ? { color: "white" } : {}),
        width: "100%",
        height: size === "sm" ? "250px" : "350px",
      }}
    >
      {image && (
        <GatsbyImage
          image={image.imageFile?.childImageSharp?.gatsbyImageData}
          style={{
            borderRadius: "1rem",

            overflow: "hidden",
            position: "absolute",
            bottom: 0,
            right: 0,
            top: 0,
            left: 0,
          }}
          objectFit="cover"
          objectPosition="50% 50%"
          alt={image.alternativeText ?? ""}
        />
      )}
      <Box
        sx={{
          position: "relative",
          marginTop: "auto",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            position: "relative",
            minHeight: "57.59px",
            display: "flex",
            alignItems: "center",
            textShadow: dark ? "0px 1px 4px rgba(27, 31, 34, 0.85)" : "none",
            [theme.breakpoints.down("lg")]: {
              minHeight: "48px",
              h4: {
                fontSize: "1.2rem !important",
                lineHeight: "1.5rem",
              },
            },
          }}
        >
          <Typography
            variant="h4"
            color={dark ? "white" : "var(--color-gradient-teal)"}
            className={dark ? "" : "gradientText"}
            fontSize={"1.5rem"}
            lineHeight={"1.8rem"}
            fontWeight={600}
          >
            {title}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ marginTop: "auto" }}></Box>
      <Box
        sx={{
          // marginTop: "auto",
          position: link?.type === "cardArrow" ? "absolute" : "relative",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
      >
        <ContentButton
          link={link ?? undefined}
          align={link?.type !== "cardArrow" ? "center" : "end"}
          allowCardAreaFill={true}
        />
      </Box>
    </Box>
  )
}

export default ImageCard
